"use client";

import { useMemo } from "react";
import API from "@/components/api/api";
import { useConfig } from "@/lib/providers/ConfigProvider";

export default function useApi() {
  const config = useConfig();

  return useMemo(
    () => API(config),
    [config.apiUrl, config.webUrl, config.secureCookies]
  );
}
